import React, { Children, cloneElement, isValidElement, useRef, useState } from 'react';
import { DropdownContainer } from "../../../dropdownContainer/DropdownContainer.js";
import styles from "../../MultiSelect.module.js";
import { MultiSelectInput } from "../MultiSelectInput/MultiSelectInput.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const MultiSelectDesktop = ({
  children,
  className,
  activeItems,
  addItem,
  inputValue,
  removeItem,
  searchable,
  ...props
}) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [searchTherm, setSearchTherm] = useState('');
  const handleClick = () => {
    if (!props.disabled) {
      if (searchable) {
        setSearchTherm('');
      }
      setOpen(!open);
    }
  };
  const handleIconClick = () => {
    if (!props.disabled) {
      if (searchable && open) {
        setSearchTherm('');
      } else {
        setOpen(!open);
      }
    }
  };
  const handleClickOutside = () => {
    setOpen(false);
  };
  const _children = Children.map(children, child => {
    if (! /*#__PURE__*/isValidElement(child)) {
      return null;
    }
    if (!child.props.label.toLowerCase().includes(searchTherm.toLowerCase())) {
      return null;
    }
    const props = {
      ...child.props,
      onChange: checked => {
        if (checked) {
          addItem(child.props.value);
        } else {
          removeItem(child.props.value);
        }
      }
    };
    return /*#__PURE__*/cloneElement(child, props);
  });
  const renderOptions = () => {
    return /*#__PURE__*/_jsx("ul", {
      className: styles.optionsList,
      children: _children
    });
  };
  function handleFilterChange(e) {
    const newValue = e.target.value;
    setSearchTherm(newValue);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MultiSelectInput, {
      ...props,
      outerRef: ref,
      onChange: handleFilterChange,
      onMouseDown: handleClick,
      onIconClick: handleIconClick,
      value: open && searchable ? searchTherm : inputValue,
      searchable: searchable,
      open: open
    }), open && /*#__PURE__*/_jsx(DropdownContainer, {
      onClickOutside: handleClickOutside,
      reference: ref,
      name: props.name,
      visible: true,
      children: renderOptions()
    })]
  });
};